import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function GroupFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/customer-accounts/customer-groups/"
  );

  return (
    <Picker
      isLoading={isLoading}
      label={t("Group")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.customer_group_id?.split(",") || []}
      onSelectionChange={(keys) =>
        setParam("customer_group_id", Array.from(keys))
      }
      items={data}
      testID="group-filter-picker"
    />
  );
}
